if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      let _this = this;

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this.infoTabs = document.querySelectorAll('[data-info-tab]');
      this.infoContent = document.querySelectorAll('[data-info-content]');

      this.infoTabs.forEach(function(infoTab) {
        infoTab.addEventListener('click', function(evt) {
          _this.infoTabs.forEach(function(_infoTab) {
            _infoTab.classList.remove('active');
          })
          this.classList.add('active')

          let tab = this.dataset.infoTab
          _this.infoContent.forEach(function(infoContent) {
            if(infoContent.dataset.infoContent == tab) {
              infoContent.classList.remove('hidden');
            } else {
              infoContent.classList.add('hidden');
            }
          })
        });
      })
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      /*
      this.cartNotification.setActiveElement(document.activeElement);
      */

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
      let formData = JSON.parse(serializeForm(this.form));
      if(document.querySelector('#otpRadio:checked') != null) {
        /* Not subscribing */
        delete formData['selling_plan'];
      }

      /*...JSON.parse(serializeForm(this.form)),*/
      /*
      **sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
      **sections_url: window.location.pathname
      */
      const body = JSON.stringify({
        ...formData,
      });

      console.log("FormData =>", formData);

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          var variantPopup = document.querySelector('.product-upsell-popup');

          variantPopup.classList.remove('active');
          if(variantPopup && popupvariantIDs.includes(parsedState.id)){
            variantPopup.classList.add('active');
          }
          
          const couponContainer = document.querySelector('.pdp-coupon');

          if(couponContainer){
            const couponMessage = couponContainer.querySelector('.pdp-coupon__title');
            const couponCode = couponContainer.dataset.code;
            const couponupdateText = couponContainer.getAttribute('data-applied');

            if(couponContainer.classList.contains('is-applied')){
              const updateRes = fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({ discount: couponCode})
              })
              .then((response) => response.json())
              .then((response) => {
                couponMessage.innerText = couponupdateText;

                sideCart.reloadCart();
                sideCart.openCart();
              });
            }else{
              sideCart.reloadCart();
              sideCart.openCart();
            }
          }else{
            sideCart.reloadCart();
            sideCart.openCart();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
        setTimeout(() => {
        document.dispatchEvent(new CustomEvent("bogos:progress-rerender"))
      }, 900) 

        function freeShippingCalc() {
          let mirrorTotal = document.getElementById('subtotalCart');
          let TotalCart = Number(mirrorTotal.innerHTML.replace(/[^0-9.-]+/g, ""));
          let CartUpdate = new CustomEvent("CartUpdate", { detail: TotalCart });
          window.dispatchEvent(CartUpdate);
          console.log("Cart updated event ----------------------- form");
        }
        //freeShippingCalc();
    }
  });
}
